"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoteIcon = exports.NeighborhoodIcon = exports.NavigationIcon = exports.NamePlateIcon = exports.MitIDIcon = exports.MinusIcon = exports.MerchantIcon = exports.LockerIcon = exports.LinkIcon = exports.LetterIcon = exports.KnockIcon = exports.IntercomIcon = exports.InstaboxBudbeeOverlappedIcons = exports.InstaHeartIcon = exports.InfoIconWhite = exports.InfoIcon = exports.IdIcon = exports.HomeIcon = exports.HelpCircleIcon = exports.HeartIcon = exports.HappyParcelPersonIcon = exports.HappyParcelIcon = exports.GroupIcon = exports.GoogleLogoIcon = exports.FlagIcon = exports.FilterIcon = exports.ExpandIcon = exports.ErrorIcon = exports.DoorIcon = exports.DialogQuestionIcon = exports.DefaultLogoIcon = exports.CustomerServiceIcon = exports.CopyIcon = exports.CodeIcon = exports.CloseIcon = exports.ClockIcon = exports.ChevronIcon = exports.ChevronCircleIcon = exports.CheckIcon = exports.CheckCircleIcon = exports.C2CIcon = exports.BuildingIcon = exports.BellIcon = exports.BankIDSeIcon = exports.BankIDNoIcon = exports.ArrowTopIcon = exports.ArrowDownIcon = exports.AppleIcon = exports.AndroidIcon = exports.AlertCircleIcon = void 0;
exports.AlertIcon = exports.ParcelReturnCancelledIcon = exports.BagIcon = exports.WeightIcon = exports.WarehouseIcon = exports.VerificationIDIcon = exports.TrustpilotLogoIcon = exports.TruckIcon = exports.TinyPinIcon = exports.TinyCheckIcon = exports.TimesCircleIcon = exports.ThumbsIcon = exports.StarIcon = exports.StairsIcon = exports.SmsIcon = exports.ShopIcon = exports.SearchIcon = exports.SadParcelPersonIcon = exports.RulerIcon = exports.ReturnIcon = exports.QuickTimeIcon = exports.PlusIcon = exports.PlacePinIcon = exports.PinIcon = exports.PhoneIcon = exports.PenIcon = exports.ParcelReturnIcon = exports.ParcelOnWayIcon = exports.ParcelIcon = exports.ParcelFailedIcon = exports.ParcelExceptionIcon = exports.ParcelDeliveredIcon = exports.ParcelCreatedIcon = exports.PadLockIcon = void 0;
const BagIcon_1 = __importDefault(require("./BagIcon"));
exports.BagIcon = BagIcon_1.default;
const AlertCircleIcon_1 = __importDefault(require("./AlertCircleIcon"));
exports.AlertCircleIcon = AlertCircleIcon_1.default;
const AndroidIcon_1 = __importDefault(require("./AndroidIcon"));
exports.AndroidIcon = AndroidIcon_1.default;
const AppleIcon_1 = __importDefault(require("./AppleIcon"));
exports.AppleIcon = AppleIcon_1.default;
const ArrowDownIcon_1 = __importDefault(require("./ArrowDownIcon"));
exports.ArrowDownIcon = ArrowDownIcon_1.default;
const ArrowTopIcon_1 = __importDefault(require("./ArrowTopIcon"));
exports.ArrowTopIcon = ArrowTopIcon_1.default;
const BankIDNoIcon_1 = __importDefault(require("./BankIDNoIcon"));
exports.BankIDNoIcon = BankIDNoIcon_1.default;
const BankIDSeIcon_1 = __importDefault(require("./BankIDSeIcon"));
exports.BankIDSeIcon = BankIDSeIcon_1.default;
const BellIcon_1 = __importDefault(require("./BellIcon"));
exports.BellIcon = BellIcon_1.default;
const BuildingIcon_1 = __importDefault(require("./BuildingIcon"));
exports.BuildingIcon = BuildingIcon_1.default;
const C2CIcon_1 = __importDefault(require("./C2CIcon"));
exports.C2CIcon = C2CIcon_1.default;
const CheckCircleIcon_1 = __importDefault(require("./CheckCircleIcon"));
exports.CheckCircleIcon = CheckCircleIcon_1.default;
const CheckIcon_1 = __importDefault(require("./CheckIcon"));
exports.CheckIcon = CheckIcon_1.default;
const ChevronCircleIcon_1 = __importDefault(require("./ChevronCircleIcon"));
exports.ChevronCircleIcon = ChevronCircleIcon_1.default;
const ChevronIcon_1 = __importDefault(require("./ChevronIcon"));
exports.ChevronIcon = ChevronIcon_1.default;
const ClockIcon_1 = __importDefault(require("./ClockIcon"));
exports.ClockIcon = ClockIcon_1.default;
const CloseIcon_1 = __importDefault(require("./CloseIcon"));
exports.CloseIcon = CloseIcon_1.default;
const CodeIcon_1 = __importDefault(require("./CodeIcon"));
exports.CodeIcon = CodeIcon_1.default;
const CopyIcon_1 = __importDefault(require("./CopyIcon"));
exports.CopyIcon = CopyIcon_1.default;
const CustomerServiceIcon_1 = __importDefault(require("./CustomerServiceIcon"));
exports.CustomerServiceIcon = CustomerServiceIcon_1.default;
const DefaultLogoIcon_1 = __importDefault(require("./DefaultLogoIcon"));
exports.DefaultLogoIcon = DefaultLogoIcon_1.default;
const DialogQuestionIcon_1 = __importDefault(require("./DialogQuestionIcon"));
exports.DialogQuestionIcon = DialogQuestionIcon_1.default;
const DoorIcon_1 = __importDefault(require("./DoorIcon"));
exports.DoorIcon = DoorIcon_1.default;
const ErrorIcon_1 = __importDefault(require("./ErrorIcon"));
exports.ErrorIcon = ErrorIcon_1.default;
const ExpandIcon_1 = __importDefault(require("./ExpandIcon"));
exports.ExpandIcon = ExpandIcon_1.default;
const FilterIcon_1 = __importDefault(require("./FilterIcon"));
exports.FilterIcon = FilterIcon_1.default;
const FlagIcon_1 = __importDefault(require("./FlagIcon"));
exports.FlagIcon = FlagIcon_1.default;
const GoogleLogoIcon_1 = __importDefault(require("./GoogleLogoIcon"));
exports.GoogleLogoIcon = GoogleLogoIcon_1.default;
const GroupIcon_1 = __importDefault(require("./GroupIcon"));
exports.GroupIcon = GroupIcon_1.default;
const HappyParcelIcon_1 = __importDefault(require("./HappyParcelIcon"));
exports.HappyParcelIcon = HappyParcelIcon_1.default;
const HappyParcelPersonIcon_1 = __importDefault(require("./HappyParcelPersonIcon"));
exports.HappyParcelPersonIcon = HappyParcelPersonIcon_1.default;
const HeartIcon_1 = __importDefault(require("./HeartIcon"));
exports.HeartIcon = HeartIcon_1.default;
const HelpCircleIcon_1 = __importDefault(require("./HelpCircleIcon"));
exports.HelpCircleIcon = HelpCircleIcon_1.default;
const HomeIcon_1 = __importDefault(require("./HomeIcon"));
exports.HomeIcon = HomeIcon_1.default;
const IdIcon_1 = __importDefault(require("./IdIcon"));
exports.IdIcon = IdIcon_1.default;
const InfoIcon_1 = __importDefault(require("./InfoIcon"));
exports.InfoIcon = InfoIcon_1.default;
const InfoIconWhite_1 = __importDefault(require("./InfoIconWhite"));
exports.InfoIconWhite = InfoIconWhite_1.default;
const InstaboxBudbeeOverlappedIcons_1 = __importDefault(require("./InstaboxBudbeeOverlappedIcons"));
exports.InstaboxBudbeeOverlappedIcons = InstaboxBudbeeOverlappedIcons_1.default;
const InstaHeartIcon_1 = __importDefault(require("./InstaHeartIcon"));
exports.InstaHeartIcon = InstaHeartIcon_1.default;
const IntercomIcon_1 = __importDefault(require("./IntercomIcon"));
exports.IntercomIcon = IntercomIcon_1.default;
const KnockIcon_1 = __importDefault(require("./KnockIcon"));
exports.KnockIcon = KnockIcon_1.default;
const LetterIcon_1 = __importDefault(require("./LetterIcon"));
exports.LetterIcon = LetterIcon_1.default;
const LinkIcon_1 = __importDefault(require("./LinkIcon"));
exports.LinkIcon = LinkIcon_1.default;
const LockerIcon_1 = __importDefault(require("./LockerIcon"));
exports.LockerIcon = LockerIcon_1.default;
const MerchantIcon_1 = __importDefault(require("./MerchantIcon"));
exports.MerchantIcon = MerchantIcon_1.default;
const MinusIcon_1 = __importDefault(require("./MinusIcon"));
exports.MinusIcon = MinusIcon_1.default;
const MitIDIcon_1 = __importDefault(require("./MitIDIcon"));
exports.MitIDIcon = MitIDIcon_1.default;
const NamePlateIcon_1 = __importDefault(require("./NamePlateIcon"));
exports.NamePlateIcon = NamePlateIcon_1.default;
const NavigationIcon_1 = __importDefault(require("./NavigationIcon"));
exports.NavigationIcon = NavigationIcon_1.default;
const NeighborhoodIcon_1 = __importDefault(require("./NeighborhoodIcon"));
exports.NeighborhoodIcon = NeighborhoodIcon_1.default;
const NoteIcon_1 = __importDefault(require("./NoteIcon"));
exports.NoteIcon = NoteIcon_1.default;
const PadLockIcon_1 = __importDefault(require("./PadLockIcon"));
exports.PadLockIcon = PadLockIcon_1.default;
const ParcelCreatedIcon_1 = __importDefault(require("./ParcelCreatedIcon"));
exports.ParcelCreatedIcon = ParcelCreatedIcon_1.default;
const ParcelDeliveredIcon_1 = __importDefault(require("./ParcelDeliveredIcon"));
exports.ParcelDeliveredIcon = ParcelDeliveredIcon_1.default;
const ParcelExceptionIcon_1 = __importDefault(require("./ParcelExceptionIcon"));
exports.ParcelExceptionIcon = ParcelExceptionIcon_1.default;
const ParcelFailedIcon_1 = __importDefault(require("./ParcelFailedIcon"));
exports.ParcelFailedIcon = ParcelFailedIcon_1.default;
const ParcelIcon_1 = __importDefault(require("./ParcelIcon"));
exports.ParcelIcon = ParcelIcon_1.default;
const ParcelOnWayIcon_1 = __importDefault(require("./ParcelOnWayIcon"));
exports.ParcelOnWayIcon = ParcelOnWayIcon_1.default;
const ParcelReturnIcon_1 = __importDefault(require("./ParcelReturnIcon"));
exports.ParcelReturnIcon = ParcelReturnIcon_1.default;
const PenIcon_1 = __importDefault(require("./PenIcon"));
exports.PenIcon = PenIcon_1.default;
const PhoneIcon_1 = __importDefault(require("./PhoneIcon"));
exports.PhoneIcon = PhoneIcon_1.default;
const PinIcon_1 = __importDefault(require("./PinIcon"));
exports.PinIcon = PinIcon_1.default;
const PlacePinIcon_1 = __importDefault(require("./PlacePinIcon"));
exports.PlacePinIcon = PlacePinIcon_1.default;
const PlusIcon_1 = __importDefault(require("./PlusIcon"));
exports.PlusIcon = PlusIcon_1.default;
const QuickTimeIcon_1 = __importDefault(require("./QuickTimeIcon"));
exports.QuickTimeIcon = QuickTimeIcon_1.default;
const ReturnIcon_1 = __importDefault(require("./ReturnIcon"));
exports.ReturnIcon = ReturnIcon_1.default;
const RulerIcon_1 = __importDefault(require("./RulerIcon"));
exports.RulerIcon = RulerIcon_1.default;
const SadParcelPersonIcon_1 = __importDefault(require("./SadParcelPersonIcon"));
exports.SadParcelPersonIcon = SadParcelPersonIcon_1.default;
const SearchIcon_1 = __importDefault(require("./SearchIcon"));
exports.SearchIcon = SearchIcon_1.default;
const ShopIcon_1 = __importDefault(require("./ShopIcon"));
exports.ShopIcon = ShopIcon_1.default;
const SmsIcon_1 = __importDefault(require("./SmsIcon"));
exports.SmsIcon = SmsIcon_1.default;
const StairsIcon_1 = __importDefault(require("./StairsIcon"));
exports.StairsIcon = StairsIcon_1.default;
const StarIcon_1 = __importDefault(require("./StarIcon"));
exports.StarIcon = StarIcon_1.default;
const ThumbsIcon_1 = __importDefault(require("./ThumbsIcon"));
exports.ThumbsIcon = ThumbsIcon_1.default;
const TimesCircleIcon_1 = __importDefault(require("./TimesCircleIcon"));
exports.TimesCircleIcon = TimesCircleIcon_1.default;
const TinyCheckIcon_1 = __importDefault(require("./TinyCheckIcon"));
exports.TinyCheckIcon = TinyCheckIcon_1.default;
const TinyPinIcon_1 = __importDefault(require("./TinyPinIcon"));
exports.TinyPinIcon = TinyPinIcon_1.default;
const TruckIcon_1 = __importDefault(require("./TruckIcon"));
exports.TruckIcon = TruckIcon_1.default;
const TrustpilotLogoIcon_1 = __importDefault(require("./TrustpilotLogoIcon"));
exports.TrustpilotLogoIcon = TrustpilotLogoIcon_1.default;
const VerificationIDIcon_1 = __importDefault(require("./VerificationIDIcon"));
exports.VerificationIDIcon = VerificationIDIcon_1.default;
const WarehouseIcon_1 = __importDefault(require("./WarehouseIcon"));
exports.WarehouseIcon = WarehouseIcon_1.default;
const WeightIcon_1 = __importDefault(require("./WeightIcon"));
exports.WeightIcon = WeightIcon_1.default;
const ParcelReturnCancelledIcon_1 = __importDefault(require("./ParcelReturnCancelledIcon"));
exports.ParcelReturnCancelledIcon = ParcelReturnCancelledIcon_1.default;
const AlertIcon_1 = __importDefault(require("./AlertIcon"));
exports.AlertIcon = AlertIcon_1.default;
